// TODO enable eslint
/* eslint-disable react/destructuring-assignment */
import React, { Component } from "react"
import PropTypes from "prop-types"

class PreventClickOnDrag extends Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    onClick: PropTypes.func.isRequired,
    onMouseDown: PropTypes.func.isRequired,
    onMouseUp: PropTypes.func.isRequired,
    clickTolerance: PropTypes.number.isRequired,
  }

  handleMouseDown = evt => {
    this.props.onMouseDown(evt)
    this.originClickX = evt.clientX
  }

  handleMouseUp = evt => {
    this.props.onMouseUp(evt)
    if (Math.abs(this.originClickX - evt.clientX) > this.props.clickTolerance) {
      this.cancelClick = true
    }
  }

  handleClick = evt => {
    if (!this.cancelClick) {
      this.props.onClick(evt)
    }

    this.cancelClick = false
    this.originClickX = null
  }

  render() {
    const childElement = React.Children.only(this.props.children)
    return React.cloneElement(childElement, {
      onMouseDown: this.handleMouseDown,
      onMouseUp: this.handleMouseUp,
      onClick: this.handleClick,
    })
  }
}

export default PreventClickOnDrag
